export default "__VITE_ASSET__1N9RE_d7__"